import Vue from 'vue';
import { ADD_TOAST_MESSAGE } from "vuex-toast";
import validate from "validate.js";
import userApi from '../api/user';

const types = {
  LOADING: 'LOADING',
  SET_FIELD: 'SET_FIELD',
  SET_SEARCH_FIELD: 'SET_SEARCH_FIELD',
  RESET_FORM: 'RESET_FORM',
  GET_LIST_SUCCESS: 'GET_LIST_SUCCESS',
  GET_LIST_FAIL: 'GET_LIST_FAIL',
  GET_ITEM_SUCCESS: 'GET_ITEM_SUCCESS',
  GET_ITEM_FAIL: 'GET_ITEM_FAIL',
  UPDATE_LOADING: 'UPDATE_LOADING',
  UPDATE_SUCCESS: 'UPDATE_SUCCESS',
  UPDATE_FAIL: 'UPDATE_FAIL',
  TOPUP_LOADING: "TOPUP_LOADING",
  TOPUP_SUCCESS: "TOPUP_SUCCESS",
  TOPUP_FAIL: "TOPUP_FAIL",
  WITHDRAW_LOADING: "WITHDRAW_LOADING",
  WITHDRAW_SUCCESS: "WITHDRAW_SUCCESS",
  WITHDRAW_FAIL: "WITHDRAW_FAIL",
  GET_USER_DISCOUNT_SUCCESS: 'GET_USER_DISCOUNT_SUCCESS',
  GET_USER_DISCOUNT_FAIL: 'GET_USER_DISCOUNT_FAIL',
  OPEN_DISCOUNT_FORM: "OPEN_DISCOUNT_FORM",
  UPDATE_DISCOUNT_LOADING: "UPDATE_DISCOUNT_LOADING",
  UPDATE_DISCOUNT_SUCCESS: "UPDATE_DISCOUNT_SUCCESS",
  UPDATE_DISCOUNT_FAIL: "UPDATE_DISCOUNT_FAIL",
  ADD_ERROR: "ADD_ERROR",
};

const infoKeys = [
  "type",
  "amountDiscount",
  "expiredAt",
];

const constraints = {
  type: {
    presence: {
      allowEmpty: false,
    },
  },
  amountDiscount: {
    presence: {
      allowEmpty: false,
    },
    numericality: {
      greaterThan: 0,
    }
  },
  expiredAt: {
    presence: {
      allowEmpty: false,
    },
  },
};

// initial state
const initalState = {
  search: {},
  list: [],
  page: 1,
  count: 0,
  total: 0,
  item: {},
  form: {},
  error: {},
  loading: false,
  form_loading: false,
  topup_loading: false,
  withdraw_loading: false,
  discountModal: false,
  isCreate: true,
  discountId: null,
  discountData: {}
};

// getters
const getters = {
  search: state => state.search,
  list: state => state.list,
  item: state => state.item,
  count: state => state.count,
  page: state => state.page,
  total: state => state.total,
  form: state => state.form,
  loading: state => state.loading,
  form_loading: state => state.form_loading,
  topup_loading: state => state.topup_loading,
  error: state => state.error,
  withdraw_loading: state => state.withdraw_loading,
  discountModal: state => state.discountModal,
  isCreate: state => state.isCreate,
  discountId: state => state.discountId,
  discountData: state => state.discountData,
};

const validateForm = (form, keys) => {
  const fullConstraints = constraints;
  const validateConstraints = _.pickBy(fullConstraints, (value, key) => {
    if (keys.includes(key)) return true;
    return false;
  });

  const errors = validate(form, validateConstraints, {
    fullMessages: false
  });
  const newErrors = Object.keys(validateConstraints).reduce(
    (acc, key) => ({
      ...acc,
      [key]: errors ? errors[key] : null
    }),
    {}
  );
  return {
    success: errors ? false : true,
    errors: newErrors
  };
};

// actions
const actions = {
  setField({ commit }, { key, value }) {
    commit(types.SET_FIELD, { key, value });
  },

  setSearchField({ commit }, { key, value }) {
    commit(types.SET_SEARCH_FIELD, { key, value });
  },

  validateField({ state, commit }, keys) {
    const { success, errors } = validateForm(
      state.form,
      keys
    );
    commit(types.ADD_ERROR, errors);
    return success;
  },

  setFieldDiscount({ commit, dispatch }, { key, value }) {
    commit(types.SET_FIELD, { key, value });
    dispatch("validateField", [key]);
  },

  async getUsers({ dispatch, commit }, { page, search }) {
    commit(types.LOADING);
    const { data } = await userApi(dispatch).getList(page, search.status, search.email);
    commit(types.GET_LIST_SUCCESS, { data, page, search });
  },

  async getUsersByRole({ dispatch, commit }, { page, search }) {
    commit(types.LOADING);
    const { data } = await userApi(dispatch).getListByRole(page, search.role);
    commit(types.GET_LIST_SUCCESS, { data, page, search });
  },

  async getUser({ dispatch, commit }, accountId) {
    try {
      commit(types.LOADING);
      const { data } = await userApi(dispatch).getOne(accountId);
      commit(types.GET_ITEM_SUCCESS, data);
    } catch (e) {
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: "Cannot get account", type: "danger" },
        { root: true }
      );
    }
  },
  
  async getUserDiscount({ dispatch, commit }, accountId) {
    try {
      const { data } = await userApi(dispatch).getUserDiscount(accountId);
      commit(types.GET_USER_DISCOUNT_SUCCESS, { formData: data, accountId: accountId });
    } catch (e) {
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: "Cannot get user discount", type: "danger" },
        { root: true }
      );
    }
  },

  async openDiscountForm({ dispatch, commit }, isCreate) {
    try {
      commit(types.OPEN_DISCOUNT_FORM, isCreate);
    } catch (e) {
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: "Cannot open form", type: "danger" },
        { root: true }
      );
    }
  },

  async confirmDiscount({ state, dispatch, commit }) {
    try {
      const { id } = state.item
      const { type, amountDiscount, expiredAt } = state.form;
      const formData = {
        "expiredAt": expiredAt,
        "type": type,
        "amount": parseFloat(amountDiscount)
      }
      const success = await dispatch("validateField", infoKeys);
      if (success) {
        commit(types.UPDATE_DISCOUNT_LOADING);
        if (state.isCreate) {
          formData['userId'] = id;
          const { data } = await userApi(dispatch).createUserDiscount(formData);
          commit(types.UPDATE_DISCOUNT_SUCCESS, data);
        } else {
          const { data } = await userApi(dispatch).updateUserDiscount(state.discountId, formData);
          commit(types.UPDATE_DISCOUNT_SUCCESS, data);
          dispatch("getUserDiscount", id);
        }
        dispatch(
          ADD_TOAST_MESSAGE,
          { text: 'Updated successfully', type: "success" },
          { root: true }
        );
      }
    } catch (e) {
      commit(types.UPDATE_DISCOUNT_FAIL);
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: "Cannot update account discount", type: "danger" },
        { root: true }
      );
    }
  },

  async addUser({ dispatch, commit, state }) {
    try {
      const { form, page, search } = state;
      const data = {
        name: form.name,
        email: form.email,
        password: form.password,
        role: form.role,
      };

      if (form.role === 'bo_manager') {
        data.backofficeCode = form.backofficeCode;
      }

      commit(types.SET_FIELD, { key: 'loading', value: true });
      await userApi(dispatch).createUser(data);
      dispatch("getUsers", { page, search });
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: 'Created user successfully', type: "success" },
        { root: true }
      );
      commit(types.RESET_FORM);
    } catch (e) {
      commit(types.SET_FIELD, { key: 'loading', value: false });
      dispatch(
        ADD_TOAST_MESSAGE,
        { text: e.data.message, type: "danger" },
        { root: true }
      );
    }
  },

  async updateUser({ dispatch, commit }, updateData) {
    const { id, status } = updateData;
    try {
      commit(types.UPDATE_LOADING, id);
      const { data } = await userApi(dispatch).updateUser(id, { status });
      commit(types.UPDATE_SUCCESS, data);
    } catch (e) {
      commit(types.UPDATE_FAIL, id);
    }
  },

};

// mutations
const mutations = {
  [types.SET_FIELD](state, params) {
    Vue.set(state.form, params.key, params.value);
  },
  [types.SET_SEARCH_FIELD](state, params) {
    const newSearch = { ...state.search, [params.key]: params.value };
    Vue.set(state, "search", newSearch);
  },
  [types.LOADING](state, loading) {
    state.loading = loading;
  },

  [types.GET_LIST_SUCCESS](state, { data, page, search }) {
    state.list = data.rows;
    state.count = data.count;
    state.total = data.total;
    state.search = search;
    state.page = page;
    state.error = {};
    state.loading = false;
  },

  [types.GET_ITEM_SUCCESS](state, data) {
    state.item = data;
    state.form = {};
    state.error = {};
    state.loading = false;
    state.topup_loading = false;
    state.withdraw_loading = false;
  },

  [types.RESET_FORM](state) {
    Vue.set(state, 'form', { show: false });
  },

  [types.UPDATE_LOADING](state, id) {
    const users = state.list.map(u => {
      if (u.id === id) {
        return { ...u, loading: true };
      }
      return u
    });
    Vue.set(state, "list", users);
  },

  [types.UPDATE_SUCCESS](state, data) {
    const users = state.list.map(u => {
      if (u.id === data.id) {
        return data;
      }
      return u
    });
    Vue.set(state, "list", users);
  },

  [types.UPDATE_FAIL](state, id) {
    const users = state.list.map(u => {
      if (u.id === id) {
        return { ...u, loading: false };
      }
      return u
    });
    Vue.set(state, "list", users);
  },

  [types.TOPUP_LOADING](state, loading) {
    state.topup_loading = loading;
  },

  [types.TOPUP_FAIL](state) {
    state.topup_loading = false;
  },

  [types.WITHDRAW_LOADING](state, loading) {
    state.withdraw_loading = loading;
  },

  [types.WITHDRAW_FAIL](state) {
    state.withdraw_loading = false;
  },

  [types.GET_USER_DISCOUNT_SUCCESS](state, obj) {
    Vue.set(state, "discountData", obj.formData);
    const index = _.findIndex(obj.formData.rows, function (o) {
      return o.userId === parseInt(obj.accountId);
    });
    Vue.set(state, "isCreate", index === -1);
  },

  [types.OPEN_DISCOUNT_FORM](state, isCreate) {
    Vue.set(state, "form", {});
    if (isCreate) {
      Vue.set(state.form, "type", 'per_order');
      Vue.set(state.form, "amountDiscount", '');
    } else {
      const item = _.find(state.discountData.rows, function (o) {
        return o.userId === parseInt(state.item.id);
      });
      Vue.set(state, "discountId", item.id);
      Vue.set(state.form, "type", item.type);
      Vue.set(state.form, "amountDiscount", item.amount);
      Vue.set(state.form, "expiredAt", item.expiredAt);
    }
    Vue.set(state.form, "discountModal", true);
    Vue.set(state, "isCreate", isCreate);
  },
  
  [types.UPDATE_DISCOUNT_LOADING](state) {
    Vue.set(state, "form_loading", true);
  },
  
  [types.UPDATE_DISCOUNT_SUCCESS](state, resData) {
    Vue.set(state, "isCreate", false);
    Vue.set(state, "form_loading", false);
    Vue.set(state.form, "discountModal", false);
    state.discountData.rows[0] = resData;
  },

  [types.UPDATE_DISCOUNT_FAIL](state) {
    Vue.set(state, "form_loading", false);
  },

  [types.ADD_ERROR](state, errors) {
    Vue.set(state, "error", {
      ...state.error,
      ...errors
    });
  },
};

export default {
  namespaced: true,
  state: initalState,
  getters,
  actions,
  mutations,
};
